// src/docs/DocsVerifiedProjects.js
import React from "react";
import { Container, Typography } from "@mui/material";

const DocsVerifiedProjects = () => {
  return (
    <Container maxWidth="md" sx={{ my: 4 }}>
      {/* Title */}
      <Typography variant="h5" sx={{ color: "#FFD700", mb: 2 }}>
        Verified Projects: Sorting &amp; Filtering
      </Typography>

      {/* Introduction */}
      <Typography variant="body1" sx={{ color: "#FFFFFF", mb: 2 }}>
        Verified projects have undergone a preliminary review process to ensure credibility and accuracy. Our platform offers robust sorting and filtering tools that help you quickly locate projects that meet your specific criteria.
      </Typography>

      {/* Sorting Options */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Sorting Options
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        You can sort verified projects based on key metrics such as:
        <br />
        • <strong>Price per Share:</strong> Arrange projects by ascending or descending token price.
        <br />
        • <strong>Total Funds Raised:</strong> Identify projects with higher or lower funding totals.
        <br />
        • <strong>Soft Cap &amp; Hard Cap:</strong> Sort by funding targets to find projects within your desired range.
      </Typography>

      {/* Filtering Options */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Filtering Options
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        Narrow down your search with filters such as:
        <br />
        • <strong>Status:</strong> Choose projects that are Active, Expired, Cancelled, or view All.
        <br />
        • <strong>Category:</strong> Filter projects based on industry or project type.
        <br />
        • <strong>Creation Date:</strong> Select projects tokenized within a specific time frame.
      </Typography>

      {/* Tips for Effective Use */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Tips for Effective Sorting &amp; Filtering
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        Combining multiple filters can help refine your search to the most promising opportunities. Experiment with different sorting orders to quickly identify projects that match your investment strategy.
      </Typography>

      {/* Conclusion */}
      <Typography variant="body1" sx={{ color: "#FFFFFF", mt: 3 }}>
        By leveraging these sorting and filtering features, you can efficiently analyze verified projects and make well-informed decisions. Use these tools to tailor the project list to your interests and investment goals.
      </Typography>
    </Container>
  );
};

export default DocsVerifiedProjects;
